/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Product {
    "use strict";

    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import SecurityEntityTypeEnum = Meevo.Model.SecurityEntityTypeEnum;

    export class ProductContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        private isTheDisplayNameValid = true;
        disableDiscontinued: boolean;
        disableVariantConsolidation: boolean;
        businessTypeCriteria: any;
        copiedStockLevels: any[];
        productUsageTrackingSettings;
        public decimalPrecision: number;
        public tenantEnableProductUsageTracking: boolean = false;
        public inventoryNegativeTracking: boolean = false;

        get customTabId(): number {
            return 99;
        }

        get customSecurityEntity(): number {
            return SecurityEntityTypeEnum.UdfProduct;
        }

        get customTabSecurityKey(): string {
            return this.securityKeys.DATA_PRODUCT_TAB_CUSTOMUDFTABS;
        }

        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        get stockLevelReadSecurityKey(): string {
            return this.securityKeys.INVENTORY_STOCKLEVEL + this.securityParts.KEY_PART_READ;
        }

        get stockLevelEditSecurityKey(): string {
            return this.securityKeys.INVENTORY_STOCKLEVEL + this.securityParts.KEY_PART_WRITE;
        }

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            customDataContextConfig: Meevo.Model.ICustomDataContextConfig,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService,
            public reportRouterService: Meevo.Components.Common.ReportRouterService,
            public $rootScope: ng.IRootScopeService,
            public $filter: angular.IFilterService) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, customDataContextConfig, true, $translate, $filter);

            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;
            this.inventoryNegativeTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.trackNegativeInventory || false;
        }
        initializeContext(): void {
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.product;
            this.sectionTemplatePath = "app/plugins/product/sectionViews/";
            this.entityType = "Product";
            this.disableVariantConsolidation = false;
            this.identityService.checkCentralOfficeLocationId;
        }

        initializeSections(): void {
            this.initializeContext();

            if (this.securityChecker.hasSecurity(this.securityKeys.DATA_PRODUCT_VARIANT_FIELD +
                Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.disableDiscontinued = false;
            } else {
                this.disableDiscontinued = true;
            }

            //this.baseEndpoint = this.appSettings.API_ENDPOINTS.product;
            this.productUsageTrackingSettings = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking;
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_PRODUCT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_PRODUCT_MAIN",
                    "main.html",
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.product,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ProductMain,
                    this.appSettings,
                    this.securityKeys.DATA_PRODUCT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));


            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_PRODUCT_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new CompensationSection(1,
                    'SECTION_EMPLOYEE_COMPENSATION',
                    'compensation.html',
                    false,
                    false,
                    this.baseEndpoint,
                    'Compensation',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.ProductCompensationTab,
                    this.modalService,
                    this.securityKeys.DATA_PRODUCT_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_PRODUCT_TAB_PRODUCTUSAGE + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && this.productUsageTrackingSettings) {
                this.sections.push(new ProductUsageSection(2,
                    'SECTION_PRODUCT_USAGE',
                    'productusage.html',
                    false,
                    false,
                    this.baseEndpoint, 
                    "Usage",
                    this.loggingService,
                    this.dataService,
                    this.modalService,
                    this.filterService,
                    this.identityService,
                    Meevo.Model.NounEnum.ProductMain,
                    this.appSettings,
                    this.securityKeys.DATA_PRODUCT_TAB_PRODUCTUSAGE + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.translateService));
            }

        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_PRODUCT_TAB_PAYROLL);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_PRODUCT_TAB_PRODUCTUSAGE);

                    // Use translate service to populate field list
                    this.locationFieldList =
                        [
                            { field: 'UsagePricing', label: this.$translate.instant("HEADER_USAGEPRICE"), checked: false },
                        ];

                    break;
                case this.customTabId: // custom tabs
                    this.buildCrudSecurityKeysBase(this.customTabSecurityKey);
                    break;
                default:
                    this.buildCrudSecurityKeys(this.securityKeys.DATA_PRODUCT_TAB_MAIN);

                    // Use translate service to populate field list
                    this.locationFieldList =
                        [
                            { field: 'ObjectState', label: this.$translate.instant("HEADER_DISCONTINUED"), checked: false },
                            { field: 'Distributor', label: this.$translate.instant("HEADER_DISTRIBUTOR"), checked: false },
                            { field: 'NoOfWeeksValid', label: this.$translate.instant("LABEL_LASTS_X_WEEKS"), checked: false },
                            { field: 'NotForSale', label: this.$translate.instant("HEADER_NOTFORSALE"), checked: false },
                            { field: 'Retail', label: this.$translate.instant("HEADER_RETAIL"), checked: false },
                            { field: 'IsInventoryTrackable', label: this.$translate.instant("HEADER_TRACKINVENTORY"), checked: false },
                            { field: 'WholeSale', label: this.$translate.instant("HEADER_WHOLESALE"), checked: false },
                        ];

                    break;
            }



            if (this.selectedSection && this.selectedSection !== item && this.navigationBlocked) {
                this.modalService.alert("MESSAGE_PENDING_CHANGES");
            } else {
                // Can't selected another section when adding and copying (!this.itemId)
                if (this.isAdding || this.isCopying || this.isEditing)
                    return;

                var prevSection = this.selectedSection;
                if (Model.Guard.isSomething(prevSection))
                    prevSection.prevUnselected(); // implement prevUnselected action

                this.selectedSection = item;

                if (!this.selectedSection.handlesOwnCrud) {
                    this.loadingInProgress = true;
                    var newSectionEndPoint = this.selectedSection.sectionEndpoint;

                    let baseEndpoint = Model.Guard.isSomething(this.selectedSection.baseEndpoint) ? this.selectedSection.baseEndpoint : this.baseEndpoint;
                    this.dataService.getSectionById(baseEndpoint, this.itemId, newSectionEndPoint, this.asLocationId).then((data: any) => {
                        this.selectedSection.model = data;
                        this.selectedSection.sectionModelRetrieved();
                        if (item.sectionId == 1)
                            this.selectedSection.activate(this.securityKeys.DATA_PRODUCT_TAB_PAYROLL);
                        if (item.sectionId == 2)
                            this.selectedSection.activate(this.securityKeys.DATA_PRODUCT_TAB_PRODUCTUSAGE);
                        else
                            this.selectedSection.activate(this.securityKeys.DATA_PRODUCT_TAB_MAIN);

                        if (this.selectedSection.isPrimarySection) {
                            this.updateCoBarData(data);
                            this.initializeHeader(data);
                        }

                    }).finally(() => {
                        this.loadingInProgress = false;
                    });
                }
                //this.selectedSection.selected(!this.selectedSection.handlesOwnCrud ? null : subSectionContentKey); // implement selected action

                this.usageTrackingLog(Meevo.Model.VerbEnum.Viewed, null, this.selectedSection.getParentItemId());
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.availableAtLocations = model.availableAtLocations;
        }

        get canSaveProduct(): boolean {
            var canSave = this.canSave;

            if (this.selectedSection instanceof MainSection) {
                var productMainSection = this.selectedSection as MainSection;
                canSave = canSave && productMainSection.model && productMainSection.model.variants && productMainSection.model.variants.length > 0;
            }

            return canSave;
        }

        save(): angular.IPromise<any> {
            var vm = this;
            if (this.canSaveProduct) {
                this.selectedSection.preSave();

                if (this.isApplicationModeCO()
                    && this.selectedSection instanceof MainSection
                    && this.selectedSection.model.locationOverride.duplicationOption === Meevo.Model.DuplicationOptionEnum.Overwrite
                ) {
                    return this.dataService.getListPaged('marketPricing', { criteria: { includeActive: true } }).then((res) => {
                        this.busyService.stop();

                        if (res.length > 1) {
                            let market = _.findWhere(res, { isDefault: true });
                            return this.modalService.okCancelHandler(this.$translate.instant('MESSAGE_PRODUCT_MARKET_OVERRIDE', { marketName: market['displayName'] })).then((res) => {
                                if (res) {
                                    return this.saveProduct();
                                }
                            });
                        } else {
                            return this.saveProduct();
                        }
                    });

                } else {
                    return this.saveProduct();
                }
            }
        }

        saveProduct(): ng.IPromise<any> {
            var vm = this;
            var isNew = (this.mode === Meevo.Model.MaintenanceFormState.Adding || this.mode === Meevo.Model.MaintenanceFormState.Copying);
            this.copiedStockLevels = this.copyVariantStockLevels(isNew);
            return super.save().then((data) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.PRODUCT_SAVED, vm.selectedSection.model);
                this.saveStockLevels(isNew);
            });
        }

        copyVariantStockLevels(isNew: boolean): any[] {
            var stockLevels = [];
            if (Model.Guard.isSomething(this.selectedSection.model["variants"])) {
                for (var i = 0; i < this.selectedSection.model["variants"].length; i++) {
                    // copy sku and barcode into the stocklevel in case it is new
                    let variant: Meevo.Model.Variant = this.selectedSection.model["variants"][i];
                    if (isNew && variant.variantStockLevels && variant.variantStockLevels.length) {
                        for (let j = 0; j < variant.variantStockLevels.length; j++) {
                            var stockLevel: any = variant.variantStockLevels[j];
                            stockLevel.sku = variant.sku;
                            stockLevel.barCode = variant.barCode;
                        }
                        if (variant.productInventoryType !== Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply) {
                            variant.variantStockLevels = variant.variantStockLevels.filter((vsl, ndx, arr) => vsl.productInventoryType == variant.productInventoryType);
                        }
                    }
                    stockLevels.push(...angular.copy(variant.variantStockLevels || []));
                }
            }
            return stockLevels;
        }

        saveStockLevels(isNew: boolean): ng.IPromise<any> {
            var stockLevels = [];

            for (var i = 0; i < this.copiedStockLevels.length; i++)
            {
                if (isNew || this.copiedStockLevels[i].wasChanged) {

                    if (this.copiedStockLevels[i].nullProductPackageTypeAndMultiplesOfValuesBeforeSaving) {
                        this.copiedStockLevels[i].productPackageType = null;
                        this.copiedStockLevels[i].multiplesOf = null;
                    }

                    if (this.copiedStockLevels[i].nullModelQuantityAndOrderPointValuesBeforeSaving) {
                        this.copiedStockLevels[i].modelQuantity = null;
                        this.copiedStockLevels[i].orderPoint = null;
                    }

                    if (isNew) {
                        // get new variant id by matching SKU and Barcode
                        let pModel = this.currentProduct;
                        let cVariant: Meevo.Model.Variant = this.copiedStockLevels[i];
                        var variant = pModel.variants.find((v, ndx, arr) => { return v.sku == cVariant.sku && v.barCode == cVariant.barCode; });
                        if (variant) {
                            this.copiedStockLevels[i].variantId = this.copiedStockLevels[i].id = variant.id;
                        }
                        this.copiedStockLevels[i].entityVersion = null;
                        this.copiedStockLevels[i].entityVersion_T = null;
                    }
                    else {
                        this.copiedStockLevels[i].id = this.copiedStockLevels[i].variantId;
                    }
                    stockLevels.push(this.copiedStockLevels[i]);
                }
            }

            if (stockLevels.length >= 1) {
                return this.dataService.customMethodData("api/Inventory/StockLevel", "POST", { StockLevels: stockLevels, ProductInventoryType: 2364 })
                    .then((data) => {
                        if (data.data != null) {
                            // update stock level entity versions based on data being returned
                            // change all revert data to tenant level records
                            // set wasChanged flag to false
                            for (var i = 0; i < data.data.length; i++) {
                                for (var j = 0; j < this.copiedStockLevels.length; j++) {

                                    if (data.data[i].productInventoryType == this.copiedStockLevels[j].productInventoryType
                                        && data.data[i].variantId == this.copiedStockLevels[j].variantId) {
                                        // update stock level entity versions based on data being returned
                                        this.copiedStockLevels[j].entityVersion = data.data[i].entityVersion;

                                        // change all revert data to tenant level records
                                        if (this.copiedStockLevels[j].nullProductPackageTypeAndMultiplesOfValuesBeforeSaving) {
                                            this.copiedStockLevels[j].nullProductPackageTypeAndMultiplesOfValuesBeforeSaving = false;
                                            this.copiedStockLevels[j].productPackageType = this.copiedStockLevels[j].productPackageType_T;
                                            this.copiedStockLevels[j].multiplesOf = this.copiedStockLevels[j].multiplesOf_T;
                                        }

                                        if (this.copiedStockLevels[j].nullModelQuantityAndOrderPointValuesBeforeSaving) {
                                            this.copiedStockLevels[j].nullModelQuantityAndOrderPointValuesBeforeSaving = false;
                                            this.copiedStockLevels[j].modelQuantity = this.copiedStockLevels[j].modelQuantity_T;
                                            this.copiedStockLevels[j].orderPoint = this.copiedStockLevels[j].orderPoint_T;
                                        }

                                        // set wasChanged flag to false
                                        if (this.copiedStockLevels[j].wasChanged) {
                                            this.copiedStockLevels[j].wasChanged = false;
                                        }
                                    }
                                }
                            }

                            // Add variant stock levels record if they dont exist (new Variant)
                            // OR Update existing variant stock level records
                            for (var i = 0; i < this.selectedSection.model["variants"].length; i++) {
                                if (this.selectedSection.model["variants"][i].variantStockLevels.length > 0) {
                                    for (var j = 0; j < this.selectedSection.model["variants"][i].variantStockLevels.length; j++) {

                                        // Add variant stock levels record if they dont exist (new Variant)
                                        if (this.selectedSection.model["variants"][i].variantStockLevels[j].entityVersion == 0) {
                                            this.selectedSection.model["variants"][i].variantStockLevels = [];
                                            for (var k = 0; k < this.copiedStockLevels.length; k++) {
                                                if (this.copiedStockLevels[k].variantId == this.selectedSection.model["variants"][i].id) {
                                                    this.selectedSection.model["variants"][i].variantStockLevels.push(this.copiedStockLevels[k]);
                                                }
                                            }
                                        }
                                        else { // Update existing variant stock level records
                                            for (var k = 0; k < this.copiedStockLevels.length; k++) {
                                                if (this.copiedStockLevels[k].variantId == this.selectedSection.model["variants"][i].id
                                                    && this.copiedStockLevels[k].productInventoryType == this.selectedSection.model["variants"][i].variantStockLevels[j].productInventoryType) {
                                                    this.selectedSection.model["variants"][i].variantStockLevels[j] = this.copiedStockLevels[k];
                                                }
                                                else if (this.copiedStockLevels[k].variantId == this.selectedSection.model["variants"][i].id && this.selectedSection.model["variants"][i].productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply && this.selectedSection.model["variants"][i].variantStockLevels.length == 1) {
                                                    this.selectedSection.model["variants"][i].variantStockLevels.push(this.copiedStockLevels[k]);
                                                }
                                                // cover the scenario where a variant Product Inventory Type was changed
                                                else if (this.copiedStockLevels[k].variantId == this.selectedSection.model["variants"][i].id && this.selectedSection.model["variants"][i].productInventoryType == this.copiedStockLevels[k].productInventoryType && !this.selectedSection.model["variants"][i].variantStockLevels.includes(this.copiedStockLevels[k]) && this.selectedSection.model["variants"][i].variantStockLevels.length < 2) {
                                                    this.selectedSection.model["variants"][i].variantStockLevels.push(this.copiedStockLevels[k]);
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    this.selectedSection.model["variants"][i].variantStockLevels = [];
                                    for (var k = 0; k < this.copiedStockLevels.length; k++) {
                                        if (this.copiedStockLevels[k].variantId == this.selectedSection.model["variants"][i].id) {
                                            this.selectedSection.model["variants"][i].variantStockLevels.push(this.copiedStockLevels[k]);
                                        }
                                    }
                                }
                            }
                        }
                    });
            }
            else {
                // Restore the previous stock level values because none of them were changed but
                // the stock levels were lost due to getting the product back from the product save
                if (this.selectedSection.model["variants"]) {
                    for (var i = 0; i < this.selectedSection.model["variants"].length; i++) {
                        if (this.selectedSection.model["variants"][i].variantStockLevels.length == 0) {
                            for (var j = 0; j < this.copiedStockLevels.length; j++) {
                                if (this.copiedStockLevels[j].variantId == this.selectedSection.model["variants"][i].id) {
                                    this.selectedSection.model["variants"][i].variantStockLevels.push(this.copiedStockLevels[j]);
                                }
                            }
                        }
                    }
                }
                return this.$q.resolve();
            }
        }

        checkForUniqueDisplayName = (name: string, id: Guid) => {
            if (this.selectedSection["backup"] != null && this.selectedSection["backup"].displayName.toLowerCase() != name.toLowerCase()) {
                this.sendApiRequest(name, id);
            } else if (this.selectedSection["backup"] == null) {
                this.sendApiRequest(name, id);
            }
        }

        sendApiRequest(name: string, id: any): void {
            if (name != "" && name != null) {
                this.dataService.customMethodData("api/Product/Validate/DisplayName/", "POST", { DisplayName: name, id: id }).then((data) => {
                    if (data.data) {
                        this.isTheDisplayNameValid = false;
                        this.modalService.alert("This product already exists. Please change the display name to a unique value.", 0);
                    } else {
                        this.isTheDisplayNameValid = true;
                    }
                });
            }
        }

        isTheDisplayNameLengthValid(): boolean {

            if (this.selectedSection.model != null && this.selectedSection.model["displayName"] != undefined && this.selectedSection.model["displayName"].length > 60)
                return false;

            return true;
        }

        returnIsTheDisplayNameValid(): boolean {

            if (this.selectedSection.model != null && this.selectedSection.model["displayName"] != undefined && this.selectedSection.model["displayName"].length > 60)
                return false;

            return this.isTheDisplayNameValid;
        }


        get currentProduct(): Model.Product {
            return this.castModel<Model.Product>();
        }

        //get showCopy(): boolean {
        //    return false;
        //}

        areAllVariantObjectStateDeleted(): boolean {
            let vm = this;

            for (var i = 0; i < vm.currentProduct.variants.length; i++) {
                if (vm.currentProduct.variants[i].objectState != Model.ObjectStateEnum.Inactive)
                    return false;
            }

            return true;
        }

        delete(): void {
            let vm = this;
            // Do not allow CO-owned items to be deleted in a location
            if (vm.isCoItemInLocation) {
                vm.modalService.alert("MESSAGE_CANNOT_DELETE_CO_ITEM", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            if (!vm.areAllVariantObjectStateDeleted()) {
                if (vm.currentProduct.variants.length === 1) {
                    vm.modalService.alert("MESSAGE_CANNOT_DELETE_PRODUCT_WITH_NO_VARIANTS", Components.Modal.ModalTranslationModes.Translate);
                } else {
                    vm.modalService.alert("MESSAGE_CANNOT_DELETE_PRODUCT", Components.Modal.ModalTranslationModes.Translate);
                }
                return;
            }
            if (this.canDelete) {
                this.modalService.warning("MESSAGE_DELETE_CONFIRMATION", 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((response: boolean) => {
                        vm.loadingInProgress = true;
                        // Patch model object state to deleted
                        vm.dataService.objectStatePatch(vm.baseEndpoint,
                            vm.itemId,
                            vm.selectedSection.model.entityVersion,
                            <number>Model.ObjectStateEnum.Deleted,
                            vm.asLocationId,
                            this.selectedSection.sectionEndpoint)
                            .then((data) => {
                                if (data) {
                                    vm.selectedSection.model = data;
                                    vm.selectedSection.sectionModelRetrieved();
                                    vm.loggingService.trace(`Delete saved.`);
                                }
                                this.postDelete();
                            })
                            .finally(() => {
                                vm.loadingInProgress = false;
                                this.usageTrackingLog(Meevo.Model.VerbEnum.DeleteButtonClicked, null);
                            });
                    });

            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
        }

        /* undelete(): void {
             let vm = this;
             if (vm.isCoItemInLocation) {
                 vm.modalService.alert("MESSAGE_CANNOT_UNDELETE_CO_ITEM", Components.Modal.ModalTranslationModes.Translate);
                 return;
             }
             if (this.canUndelete) {
                 vm.loadingInProgress = true;
                 // Patch model object state to inactive
                 vm.dataService.objectStatePatch(this.baseEndpoint,
                     vm.itemId,
                     vm.selectedSection.model.entityVersion,
                     <number>Model.ObjectStateEnum.Active,
                     vm.asLocationId,
                     this.selectedSection.sectionEndpoint)
                     .then((data) => {
                         if (data) {
                             vm.selectedSection.model = data;
                             vm.selectedSection.sectionModelRetrieved();
                             vm.loggingService.trace(`Undelete saved.`);
                             this.edit();
                         }
                     })
                     .finally(() => {
                         vm.loadingInProgress = false;
                         this.usageTrackingLog(Meevo.Model.VerbEnum.UndeleteButtonClicked, null);
                     });
             } else {
                 this.modalService.alert("ERROR_HTTP_403");
             }
         }*/

        takeOwnershipClicked(): void {
            if (this.mode == Meevo.Model.MaintenanceFormState.Editing)
                this.usageTrackingLog(Meevo.Model.VerbEnum.TakeOwnership, null);

            if (this.takeOwnership) {
                var product = this.currentProduct;
                for (var i = 0; i < product.distributors.length; i++)
                    this.removeDistributor(i);

                product.productSubCategory = null;
                product.productSubCategoryId = null;

                product.manufacturer = null;
                product.manufacturerId = null;
            }
        }

        addDistributor(): void {
            var product = this.currentProduct;
            if (product === undefined || product.distributor === undefined)
                return;

            if (_.find(product.distributor !== undefined
                && product.distributors, (ec) => {
                    return ec.displayName === product.distributor.displayName
                }) === undefined) {
                {
                    if (this.isApplicationModeCO())
                        product.distributor["AddedByCO"] = true;

                    product.distributors.push(product.distributor);
                    product.distributor = undefined;
                }
            }
        }

        removeDistributor(index: number): void {
            var product = this.currentProduct;
            if (product === undefined || this.isReadonly)
                return;
            product.distributors.splice(index, 1);
        }

        get currentVariant(): Model.Variant {
            return this.castModel<Model.Variant>();
        }

        addFloorLocation(variant: Model.Variant): void {
            if (!variant.floorLocation) return;

            if (variant.floorLocations.some(fl => fl.id === variant.floorLocation.id)) return;

            variant.floorLocations.push(variant.floorLocation);
            variant.floorLocation = null;
        }

        removeFloorLocation(variant: Model.Variant, index: number): void {
            if (index >= 0) {
                variant.floorLocations.splice(index, 1);
            }
        }

        cancel(): void {
            if (this.canCancel) {
                this.selectedSection.rollbackChanges();
                this.takeOwnership = false;
                this.disableVariantConsolidation = true;

                var productChipsElement = document.getElementById("productChipAttributes");

                if (productChipsElement != null) {
                    productChipsElement["value"] = "";
                }

                if (this.isAdding) {
                    this.setMode(Model.MaintenanceFormState.Readonly);
                    this.postCancel();

                    // Typically causes the form to return to the search page.
                    // Implementation of deactivate needs to be supplied by the controller.
                    this.deactivate();
                }
                else {
                    var productChipsElement = document.getElementById("productChipAttributes");

                    if (productChipsElement != null) {
                        productChipsElement["value"] = "";
                    }

                    this.setMode(Model.MaintenanceFormState.Readonly);
                    this.postCancel();
                }
            }
        }

        enforceNotForSale(variant: any): void {
            if (variant.productInventoryType === Meevo.Model.ProductInventoryTypeEnum.ShopSupply) {
                variant.notForSale = true;
            }
        }

        postCopy(): void {
            // usage tracking for copy
            let originalModel = this.selectedSection ? this.selectedSection.originalEntity : null;
            if (originalModel) {
                this.usageTrackingLog(Meevo.Model.VerbEnum.CopyButtonClicked, null);
            }
            if (_.isFunction((<any>this.selectedSection).postCopy)) {
                (<any>this.selectedSection).postCopy();
            }
            // The purpose of this code is to handle new DB changes which require the EntityVersion to be set to 0 in order for the primary key to be generated for the appropriate model
            if (this.selectedSection != null && this.selectedSection.model != null)
                this.selectedSection.model.entityVersion = 0;
            // Since displayName is cleared out upon copy in context, headerContent needs to be initialized as well
            this.headerContent = undefined;
            this.selectedSection.model.objectState = Model.ObjectStateEnum.Active;
            this.selectedSection.model["fileGuid"] = undefined;
            this.selectedSection.model["meevoFile"] = undefined;
            this.selectedSection.model["isStorageUpdated"] = undefined;

            if (this.selectedSection.model["variants"] != null &&
                this.selectedSection.model["variants"].length == 1 &&
                this.selectedSection.model["variants"][0]["displayName"] == "default") {
                this.selectedSection.model["displayName"] = null;
                this.selectedSection.model["variants"][0]["id"] = Guid.newSqlSequentialGuid().toString();
                this.selectedSection.model["variants"][0]["barCode"] = null;
                this.selectedSection.model["variants"][0]["sku"] = null;
                this.selectedSection.model["variants"][0]["floorLocation"] = null;
                this.selectedSection.model["variants"][0]["variantDistributorIds"] = [];
            } else {
                this.selectedSection.model["displayName"] = null;
                this.selectedSection.model["productVariantAttributes"] = [];

                this.selectedSection.model["productVariantAttributes"].push({ Id: Guid.newSqlSequentialGuid().toString(), index: this.selectedSection.model["productVariantAttributes"].length, displayName: [], productVariations: [], variantType: null, sortOrder: this.selectedSection.model["productVariantAttributes"].length });

                this.selectedSection.model["variants"] = [];
            }
        }

        onBusinessTypeChange(): void {
            if (this.selectedSection instanceof MainSection) {

                this.businessTypeCriteria["coBusinessTypeId"] = this.selectedSection.model.businessTypeDetail.id;

                if (this.businessTypeCriteria["coBusinessTypeId"] != "00000000-0000-0000-0000-000000000001") {
                    this.selectedSection.model["productSubCategory"] = null;
                    this.selectedSection.model["distributor"] = null;
                    this.selectedSection.model["manufacturer"] = null;
                }
            }
        }

        edit() {
            super.edit();
            this.disableVariantConsolidation = false;
        }

        print() {
            var productCopy = angular.copy((this.selectedSection as Meevo.Plugins.Product.MainSection).model);

            const callbackFn = (items) => {
                
                const itemsArray = []; 

                for (var i = 0; i < items.length; i++) {
                    let item = items[i];
                    let newObject = {
                        barCode: item.barCode,
                        generalDisplayName: item.sku + " - " + productCopy.displayName,
                        numberOfLabels: item.numberOfLabels || 0,
                        productDisplayName: productCopy.displayName,
                        product_TId: productCopy.id,
                        sku: item.sku,
                        variant_TId: item.id,
                        variantDisplayName: item.displayName
                    };

                    if (i === 0 || items[i].id != items[i - 1].id) {
                        itemsArray.push(newObject);
                    }
                    else {
                        itemsArray[itemsArray.length - 1].numberOfLabels += items[i].numberOfLabels;
                    }
                }

                var obj = {
                    item: itemsArray,
                    reportContextValues: {
                        ProductListWithLabelCounts_TBL: itemsArray,
                        displayName: this.selectedSection.model['displayName']
                    }
                };

                //Open DP005 Code to transfer to report
                return this.reportRouterService.routeToReportWithData(this.meevoSecurityKeys.REPORTS_PRODUCT_DP005, obj);
            };

            for (var i = productCopy.variants.length - 1; i >= 0; i--) {
                var pv = productCopy.variants[i];
                if (pv.productInventoryType == Model.ProductInventoryTypeEnum.RetailOrShopSupply) {
                    let newVariant = angular.copy(pv);
                    pv.productInventoryType = Model.ProductInventoryTypeEnum.ShopSupply;
                    let stockLevel = _.findWhere(pv.variantStockLevels, { productInventoryType: Model.ProductInventoryTypeEnum.ShopSupply });
                    if (stockLevel) {
                        pv.onHand = stockLevel.onHand;
                    }

                    newVariant.productInventoryType = Model.ProductInventoryTypeEnum.Retail;
                    let stockLevel2 = _.findWhere(newVariant.variantStockLevels, { productInventoryType: Model.ProductInventoryTypeEnum.Retail });
                    if (stockLevel2) {
                        newVariant.onHand = stockLevel2.onHand;
                    }
                    productCopy.variants.splice(i, 0, newVariant);
                }
                else {
                    let stockLevel = _.findWhere(pv.variantStockLevels, { productInventoryType: pv.productInventoryType });
                    if (stockLevel) {
                        pv.onHand = stockLevel.onHand;
                    }
                }
            }

            const modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/product/printDialog/printModal.template.html",
                controller: "meevo.plugins.product.PrintModalController",
                controllerAs: "vm",

                bindToController: true,
                locals: {
                    product: productCopy,
                    callback: callbackFn
                }
            };

            return this.modalService.showCustom(modalOptions);
        }

        productInformation(event): void {
            event.stopPropagation();
            console.log('productInformation', this.currentVariant, this.currentProduct);
            var modalOptions: ProductInfoModalOptions = {
                productId: this.currentVariant.id,
                parentType: ProductInfoModalParent.Product
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/product/modals/productInformation.template.html",
                controller: "meevo.plugins.product.ProductInformationController",
                controllerAs: "vm",
                bindToController: true,
                escapeToClose: true,
                locals: {
                    options: modalOptions
                }
            }
            this.modalService.showCustom(options);
        }

        getProductUsageSnapshot(productVariant) {
            if (!productVariant.chargeClientForUsage) {
                productVariant.chargeClientForUsage = false;
            }
            let productUsageSnapshot = {
                initialChargeClientForUsage:  productVariant.chargeClientForUsage,
                initialChargeAmount: productVariant.chargeAmount,
                initialChargeType: productVariant.chargeType
            }
            return productUsageSnapshot
        }
    }
}